import { render } from "./App.vue?vue&type=template&id=f775eebe"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f775eebe&lang=css"

import exportComponent from "../../../../../../../2026-11-02/referenced-chatgpt-conversation-this-is-an-4/outputs/docker-delivery-user-management/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__